const theme = {
  amplioColor: "#3575D3",
  darkSlateBlue: "#29436D",
  softGrey: "#E0E0E0",
  babyHover: "#94C5FE",
  typography: {
    useNextVariants: true,
  },
  palette: {
    type: "light", // Switching the dark mode on is a single property value change.
    primary: {
      light: "#757ce8",
      // main: "#3aabe2", //get from amplioColor defined at top
      dark: "#309ccc", // hover color
      contrastText: "#fff", // text color
    },
    secondary: {
      light: "#ff7961",
      main: "#D0D0D0",
      dark: "#a9a7a7",
      contrastText: "#000",
    },
    textSecondary: {
      light: "#4596e8",
      main: "#4596e8",
      dark: "#4596e8",
      contrastText: "#fff",
    },
    error: {
      light: "#ff6961",
      main: "#ff6961",
      dark: "#ff6961",
      contrastText: "#fff",
    },
  },
  textColor: "black",
  backgrounds: {
    gray: "#F2F2F2",
  },
  form: {
    textField: {
      width: "200px",
    },
    menu: {
      width: "200px",
    },
    button: {
      color: "primary",
      okColor: "primary",
      cancelColor: "secondary",
      variant: "contained",
      dangerColor: "error",
    },
    input: {
      width: "240px",
      height: "14px",
      padding: "10px 20px",
      fontFamily: "'Rubik', sans-serif",
      fontWeight: "300",
      fontSize: "16px",
      border: "1px solid #aaa",
      "-webkit-appearance": "none",
    },
  },
  loadingIndicator: {
    main: {
      style: {
        position: "absolute",
        top: "50%",
        left: "50%",
      },
      size: "100px", // Will be the size for loading when entire page needed to be loaded
    },
    table: {
      style: {
        textAlign: "center",
      },
      size: "50px", // Will be the size for loading when we are on a grid table
    },
  },
  notifications: {
    error: {
      backgroundColor: "red",
      color: "white",
    },
    success: {
      backgroundColor: "green",
      color: "white",
    },
  },
  elipsis: {
    display: "inline-block",
    width: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden !important",
    textOverflow: "ellipsis",
  },
  screen_xs_max: "1000px",
  textBlue: "#4596e8",
  textLeft: {
    textAlign: "left",
  },
  textRight: {
    textAlign: "right",
  },
  iconSizes: {
    large: {
      width: 60,
      height: 60,
    },
  },
  errorPage: {
    height: "100%",
    margin: 0,
    display: "inline-grid",
    "& .content": {
      display: "flex",
      alignItems: "center",
      textAlign: "center",
    },
  },
  percentageColors: {
    good: "#339900",
    goodHighlighted: "#00FF37",
    bad: "#982014",
    badHighlighted: "#FD3431",
  },
  grid: {
    backgrounds: {
      full: "#F6F6F6",
      partial: "#F1F1F1",
      columnsHeader: "#D6D6D6",
    },
    border: "#DFDFDF",
  },
};

theme.palette.primary.main = theme.amplioColor;

export default theme;
